import { useEffect, useLayoutEffect } from 'react';

const useHomeScrollStability = ({ location, resolvedUid }) => {
  useEffect(() => {
    if (typeof window === 'undefined' || window.innerWidth > 600) return;

    let prev = 'auto';

    try {
      prev = window.history.scrollRestoration || 'auto';
      window.history.scrollRestoration = 'manual';
    } catch {}

    return () => {
      try {
        window.history.scrollRestoration = prev;
      } catch {}
    };
  }, []);

  useLayoutEffect(() => {
    if (typeof window === 'undefined' || window.innerWidth > 600) return;
    if (location && location.pathname !== '/') return;

    const alignTop = () => {
      try {
        window.scrollTo(0, 0);
      } catch {}
    };

    alignTop();

    let rafId = null;
    let t1 = null;
    let t2 = null;

    try {
      rafId = window.requestAnimationFrame(() => {
        try { alignTop(); } catch {}
      });
    } catch {}

    try {
      t1 = window.setTimeout(() => {
        try { alignTop(); } catch {}
      }, 120);
    } catch {}

    try {
      t2 = window.setTimeout(() => {
        try { alignTop(); } catch {}
      }, 360);
    } catch {}

    return () => {
      try { if (rafId) window.cancelAnimationFrame(rafId); } catch {}
      try { if (t1) window.clearTimeout(t1); } catch {}
      try { if (t2) window.clearTimeout(t2); } catch {}
    };
  }, [location, location?.pathname, location?.key, resolvedUid]);
};

export default useHomeScrollStability;
